import React from 'react';
import { useQuery } from 'react-query';
import { GetCommunityComments } from 'services/apiServices';
import { Errors, TCommunityCommentsResult } from 'types/ApiServicesTypes';
import { debounce } from 'lodash';

const WAIT_INTERVAL = 300;

export default function useGetCommunityComments(
  page = 1, 
  pageSize = 10, 
  ideaId?: number, 
  strategyId?: number
) {
  const [currentPage, setCurrentPage] = React.useState(page);

  const objQuery = useQuery<TCommunityCommentsResult, Errors>(
    ['GetCommunityComments', currentPage, pageSize, ideaId, strategyId],
    () => GetCommunityComments(currentPage, pageSize, ideaId, strategyId),
    {
      enabled: !!(ideaId || strategyId), // Only run query if we have an ideaId or strategyId
    }
  );

  const { refetch } = objQuery;

  const debouncedRefetch = React.useMemo(() => {
    return debounce(refetch, WAIT_INTERVAL);
  }, [refetch]);

  // If the page changes, refetch the data
  React.useEffect(() => {
    if (ideaId || strategyId) {
      void refetch();
    }
  }, [currentPage, refetch, ideaId, strategyId]);

  return {
    ...objQuery,
    currentPage,
    setCurrentPage,
  };
} 